// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4888":"513cd9e0","5465":"513cd9e0","6218":"513cd9e0","8716":"513cd9e0"}[chunkId] + ".chunk.css";
};